// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f2c8eb36","977":"272c824d"}[chunkId] + ".chunk.js";
};